import { gql } from "@apollo/client";

export const GetMrfs = gql`
  query GetMrfs(
    $token: String!
    $after: Cursor
    $first: Int
    $finYrId: ID!
    $customerId: ID!
    $orderBy: AtsMrfMstOrder
    $queryType: MrfQueryType!
    $start_date: Time!
    $end_date: Time!
    $name: String
  ) {
    GetMrfs(
      token: $token
      after: $after
      first: $first
      finYrId: $finYrId
      customerId: $customerId
      orderBy: $orderBy
      queryType: $queryType
      start_date: $start_date
      end_date: $end_date
      where: { or: [{ mrfNoContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          mrfNo
          mrfDate
          acceptStatus
          raisedByUserDetails {
            id
            name
          }
          subsidiary {
            id
            name
          }
          itemQty
          totalQty
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetMrfTrns = gql`
  query GetMrfTrns(
    $token: String!
    $after: Cursor
    $first: Int
    $finYrId: ID!
    $customerId: ID!
    $queryType: MrfTrnQueryType!
    $mrfId: ID!
    $orderBy: AtsMrfTrnOrder
    $name: String
  ) {
    GetMrfTrns(
      token: $token
      after: $after
      first: $first
      finYrId: $finYrId
      customerId: $customerId
      queryType: $queryType
      mrfId: $mrfId
      orderBy: $orderBy
      where: { or: [{ hasMrfWith: { or: [{ mrfNoContainsFold: $name }] } }] }
    ) {
      edges {
        node {
          id
          itemID
          uom
          udfItemDesc
          presentStk
          reqQty
          approxRate
          taxable
          tax
          acceptValue
          priority
          trnNeedBefore
          preferedSupplierIds
          usedFor
          remarks
          acceptStatus
          acceptQty
          acceptRemarks
          preferedSupplierDetails {
            id
            desc
          }
          mrf {
            mrfNo
            mrfDate
            remarks
            acceptStatus
            subsidiary {
              name
            }
            refNo
            subsidiary {
              id
              name
            }
            raisedByUserDetails {
              name
            }
          }
          item {
            desc
            uom
            id
            code
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const MrfTrsByNode = gql`
  query MrfTrsByNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsMrfTrn {
        presentStk
        reqQty
        approxRate
        taxable
        tax
        priority
        trnNeedBefore
        remarks
        udfItemDesc
        usedFor
        mrf {
          subsidiary {
            name
          }
        }
        preferedSupplierDetails {
          id
          desc
        }
        item {
          uomDetails {
            uom
            uomDesc
          }
        }
      }
    }
  }
`;

export const MrfByNode = gql`
  query MrfByNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsMrfMst {
        id
        mrfNo
        mrfDate
      }
    }
  }
`;

export const GetMrfsForOptions = gql`
  query GetMrfsForOptions(
    $token: String!
    $after: Cursor
    $first: Int
    $finYrId: ID!
    $customerId: ID!
    $orderBy: AtsMrfMstOrder
    $queryType: MrfQueryType!
    $name: String
  ) {
    GetMrfs(
      token: $token
      after: $after
      first: $first
      finYrId: $finYrId
      customerId: $customerId
      orderBy: $orderBy
      queryType: $queryType
      where: { or: [{ mrfNoContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          mrfNo
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetMrfTrnsForOptions = gql`
  query GetMrfTrnsForOptions(
    $token: String!
    $after: Cursor
    $first: Int
    $finYrId: ID!
    $customerId: ID!
    $mrfId: ID!
    $orderBy: AtsMrfTrnOrder
    $queryType: MrfTrnQueryType!
    $name: String
  ) {
    GetMrfTrns(
      token: $token
      after: $after
      first: $first
      finYrId: $finYrId
      customerId: $customerId
      mrfId: $mrfId
      orderBy: $orderBy
      queryType: $queryType
      where: { or: [{ hasMrfWith: { or: [{ mrfNoContainsFold: $name }] } }] }
    ) {
      edges {
        node {
          item {
            desc
            uom
            id
            code
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GetMrfsForPO = gql`
  query GetMrfs(
    $token: String!
    $after: Cursor
    $first: Int
    $finYrId: ID!
    $customerId: ID!
    $orderBy: AtsMrfMstOrder
    $queryType: MrfQueryType!
    $start_date: Time!
    $end_date: Time!
    $name: String
  ) {
    GetMrfs(
      token: $token
      after: $after
      first: $first
      finYrId: $finYrId
      customerId: $customerId
      orderBy: $orderBy
      queryType: $queryType
      start_date: $start_date
      end_date: $end_date
      where: { or: [{ mrfNoContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          mrfNo
          mrfDate
          rfqPendingItems {
            id
            slNo
            udfItemDesc
            uom
            acceptQty
            acceptRate
            approxOtherRate
            taxable
            tax
            approxInstRate
            approxDlvryRate
            item {
              id
            }
          }
          rfqCompletedItems {
            id
            slNo
            udfItemDesc
            uom
            acceptQty
            acceptRate
            approxOtherRate
            taxable
            tax
            approxInstRate
            approxDlvryRate
            item {
              id
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetMrfByNode = gql`
  query GetMrfByNode($token: String!, $id: ID!) {
    node(id: $id, token: $token) {
      id
      ... on AtsMrfMst {
        id
        mrfNo
        mrfDate
        rfqPendingItems {
          id
          slNo
          udfItemDesc
          uom
          acceptQty
          acceptRate
          approxOtherRate
          taxable
          tax
          approxInstRate
          approxDlvryRate
          item {
            id
          }
        }
        rfqCompletedItems {
          id
          slNo
          udfItemDesc
          uom
          acceptQty
          acceptRate
          approxOtherRate
          taxable
          tax
          approxInstRate
          approxDlvryRate
          item {
            id
          }
        }
      }
    }
  }
`;
